import React, { Component } from 'react';
import classes from './Reveals.module.scss';

class Reveal extends Component {

  constructor(props) {
    super(props);

    const elements = [];
    // const childrens = [];

    // if (typeof props.children[Symbol.iterator] === 'function') 
    //   props.children.forEach(c => childrens.push(c));
    // else 
    //   childrens.push(props.children);

    React.Children.forEach(this.props.children, (child, i) => {
      const elem = {
        key: i,
        classNames: [classes.Reveal],
        ref: null,
        revealed: false
      };
      if (child.props.className) elem.classNames.push(child.props.className);
      if (!this.props.fade) elem.classNames.push(classes.Static);
      elements.push(elem);
    })
    
    // childrens.forEach((child, i) => {
    //   const elem = {
    //     key: i,
    //     type: child.type,
    //     props: child.props,
    //     children: child.props.children,
    //     classNames: [classes.Reveal],
    //     ref: null,
    //     revealed: false
    //   };
    //   if (child.props.className) elem.classNames.push(child.props.className);
    //   elements.push(elem);
    // });
    this.childElements = elements;
    this.offsetFraction = props.offsetFraction ? props.offsetFraction : 0.5;

    this.state = {
      childAmmount: elements.length
    };
  }

  componentDidMount() {
    window.addEventListener('scroll', this.scrollEvent);
  }

  resetChildElements() {
    const elements = [];
    const childrens = [];

    if (typeof this.props.children[Symbol.iterator] === 'function') 
      this.props.children.forEach(c => childrens.push(c));
    else 
      childrens.push(this.props.children);

    childrens.forEach((child, i) => {
      if (i >= this.childElements.length)
        return;
      const elem = {
        ...this.childElements[i],
        props: child.props,
        children: child.props.children
      };
      elements.push(elem);
    });
    this.childElements = elements;
    this.offsetFraction = this.props.offsetFraction ? this.props.offsetFraction : 0.5;
  }
  
  scrollEvent = () => {
    if (this.state.childAmmount <= 0) {
      window.removeEventListener('scroll', this.scrollEvent);
      return;
    }

    let changed = 0;
    this.childElements.forEach((child, i) => {
      if (!child.ref || child.revealed)
        return;
      const childRect = child.ref.getBoundingClientRect();
      
      const childOffset = childRect.top
                          + childRect.height * this.offsetFraction
                          - window.innerHeight;

      if (childOffset < 0) {
        if (this.props.fade) child.classNames.push(classes.Show);
        child.revealed = true
        changed++;
      }
    });

    if (changed > 0) {
      this.setState({ childAmmount: this.state.childAmmount - changed });
      // console.log(this.childElements.filter(c => !c.revealed).length);
      if (this.childElements.filter(c => !c.revealed).length === 0) {
        // console.log("Reveal onReveal", this.props.onReveal);
        if (this.props.onReveal) {
          // console.log('RRRRR');
          this.props.onReveal();
        }
      }
    }
  }

  render() {
    // console.log(this.childElements, this.state.childAmmount);  
    // this.resetChildElements();
    // const childElementNodes = this.childElements.map((child, i) => {
    //   const props = {
    //     ...child.props,
    //     key: child.key,
    //     className: child.classNames.join(' '),
    //     ref: (ref) => child.ref = ref
    //   };
    //   return React.createElement(child.type, props);
    // })

    const childElementNodes = React.Children.map(this.props.children, (child, i) => {
      const props = {
        key: this.childElements[i].key,
        className: this.childElements[i].classNames.join(' '),
        ref: ref => this.childElements[i].ref = ref
      }
      if (React.isValidElement(child)) {
        return React.cloneElement(child, props);
      }
      return child;
    })

    return (
      <React.Fragment>
        { this.props.onReveal ?
          childElementNodes :
          childElementNodes
        }
      </React.Fragment>
    );
  }
}

export default Reveal;
